/**
 * Whether the signed-in user has closed the failed-payment notice (Task #1840).
 *
 * Hidden until the next sign-in: the flag survives reloads and navigation, and is cleared by the
 * auth store on logout and on a successful sign-in callback. Storage may be blocked or full, so
 * every access is guarded; an unreadable flag means "not dismissed", so the notice is never
 * hidden by accident.
 */
const KEY = 'sc_payment_issue_banner_dismissed'

export function dismiss(): void {
  try {
    localStorage.setItem(KEY, '1')
  } catch {
    // best-effort: the component still hides itself for this page load
  }
}

export function isDismissed(): boolean {
  try {
    return localStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function clear(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    // best-effort
  }
}
